<div class="tab-filter">
  <shared-filter-bar
    [text]="true"
    [organizations]="true"
    [resultsCount]="recordCount"
    [(filteredText)]="filteredText"
    [(filteredOrganizations)]="filteredOrganizations"
    (refreshData)="refreshPublishData()"
  >
    <!-- <ng-container other-buttons>
      <button styles-icon-button class="icon-button" (click)="state = 'list'">
        <mat-icon>format_list_bulleted</mat-icon>
      </button>
      <button styles-icon-button class="icon-button" (click)="state = 'image'">
        <mat-icon>grid_on</mat-icon>
      </button>
    </ng-container>-->
  </shared-filter-bar>
  <!-- <mat-progress-bar *ngIf="loading?.loadingObs | async" mode="indeterminate"></mat-progress-bar> -->
</div>

<div class="spacer"></div>
<ng-container *ngIf="searchResults$ | async as searchResults; else loadingTemplate">
  <div class="search-wrapper" *ngIf="searchResults?.items?.length ; else noData ">
    <search-results-box [results]="searchResults?.items"></search-results-box>
  </div>
  <shared-paging-button
    (frameworkInView)="options.loadMore()"
    [loading]="options.loading"
    *ngIf="searchResults.currentPage  < searchResults.totalPages"
  >
  </shared-paging-button>
</ng-container>

<ng-template #loadingTemplate>
  <div class="search-wrapper">
    <elements-loading-spinner></elements-loading-spinner>
  </div>
</ng-template>

<ng-template #noData>
  <div class="search-wrapper">
    <div class="no-data">No Data Found</div>
  </div>
</ng-template>
